window.app_config = {
  base_api_url: 'https://dev.ascendco.cloud:4430/api',
  fallback_api_url: 'https://dev.ascendco.cloud:4430/api',
  image_base_url: 'https://static.ascendco.cloud',
  base_pdf_url: 'https://dev.ascendco.cloud:4430'
};
